import React from "react";
import { Routes, Route } from 'react-router-dom';

const PostCollect = React.lazy(() => import('pages/post/PostCollect'))
const PostGoods = React.lazy(() => import('pages/post/PostGoods'))
const PostFirstArticle = React.lazy(() => import('pages/post/PostFirstArticle'));

export const URL_POST = '/post';
export const URL_POST_COLLECT = '/collect';
export const URL_POST_GOODS = '/goods';
export const URL_POST_FIRST_ARTICLE = '/first-article';

/**
 * 배송 관리자
 * @returns
 */
const PostRoute = ({ common }) => {
  return (
    <Routes>
      <Route path={URL_POST_COLLECT} element={<PostCollect common={common} />} />
      <Route path={URL_POST_GOODS} element={<PostGoods common={common} />} />
      <Route path={URL_POST_FIRST_ARTICLE} element={<PostFirstArticle common={common} />} />
    </Routes>
  )
}

export default PostRoute;